import React from "react";

const locationsData = [
  {
    title: "Chennai",
    img: "https://media.istockphoto.com/id/1226340114/photo/puratchi-thalaivar-dr-mgr-central-railway-station-chennai-central-railway-station-india.jpg?s=612x612&w=0&k=20&c=lZjBnWBBoLiApWZUUWP1Vl3XAVdKjYMcgGpItXv_L14=",
    address:
      "MyCareergems EduTech, Door No. 43, Plot No. 18, Madurai Meenakshipuram, Urapakkam, Chengalpattu, Tamil Nadu - 603210",
  },
  {
    title: "Arunachal Pradesh",
    img: "https://images.travelandleisureasia.com/wp-content/uploads/sites/3/2024/12/18115131/bomdila-monastery.jpeg",
    address:
      "My Career Gems EduTech, Nyigam Colony, Lower Model Village, Naharlagun, Arunachal Pradesh - 791110. Landmark: UpGrade Academy",
  },
  {
    title: "Sikkim",
    img: "https://www.esikkimtourism.in/wp-content/uploads/2019/04/topmarch.jpg",
    address:
      "MyCareergems EduTech, 8/4, Tibet Rd, Arithang, Gangtok, Sikkim - 737101. Landmark: Opposite to National Horticulture Board Sikkim",
  },
];

const Locations = () => {
  return (
    <div className="bg-light py-5">
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="fw-bold text-primary">Our Locations</h2>
          <p className="text-muted fs-5">
            We are available in various cities across India. Find the nearest center to you!
          </p>
        </div>

        <div className="row g-4">
          {locationsData.map((location, idx) => (
            <div key={idx} className="col-lg-4 col-md-6">
              <div
                className="card border-0 shadow-lg rounded-4 h-100"
                style={{ overflow: "hidden" }}
              >
                <div className="position-relative">
                  <img
                    src={location.img}
                    alt={location.title}
                    className="w-100"
                    style={{ height: "220px", objectFit: "cover" }}
                  />
                  <div
                    className="position-absolute bottom-0 start-0 w-100 text-white fw-bold text-center py-2"
                    style={{
                      background: "rgba(0,0,0,0.5)",
                      fontSize: "1.1rem",
                      letterSpacing: "1px",
                    }}
                  >
                    {location.title}
                  </div>
                </div>

                <div className="card-body p-4 d-flex flex-column">
                  <div
                    className="p-3 rounded-3"
                    style={{
                      backgroundColor: "#f8f9fa",
                      borderLeft: "4px solid #0d6efd",
                    }}
                  >
                    <p
                      className="mb-0 text-muted"
                      style={{ lineHeight: "1.6", fontSize: "0.95rem" }}
                    >
                      {location.address}
                    </p>
                  </div>
                  <div className="mt-auto pt-3 text-center">
                    <a
                      href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                        location.address
                      )}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-outline-primary btn-sm rounded-pill"
                    >
                      View on Map
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Locations;
